// Sistema per scoprire automaticamente i modelli disponibili sul server
import {ASSETS_CONFIG, getModelPath, testModelLoad} from './assets-config'

// Lista di possibili nomi di modelli da testare
const POSSIBLE_MODELS = [
  // Modelli già configurati
  'castel-oggi.glb',
  'Tuta_amianto.glb',
  
  // Modelli comuni che potrebbero esistere
  'venere.glb',
  'soldato.glb',
  'colosseo.glb',
  'nave.glb',
  'automobile.glb',
  'strumento.glb',
  'statua.glb',
  'edificio.glb',
  'personaggio.glb',
  'oggetto.glb',
  'monumento.glb',
  'scultura.glb',
  'macchina.glb',
  'barca.glb',
  'aereo.glb',
  'moto.glb',
  'bicicletta.glb',
  'treno.glb',
  'elicottero.glb',
  'robot.glb',
  'animale.glb',
  'pianta.glb',
  'albero.glb',
  'fiore.glb',
  'roccia.glb',
  'montagna.glb',
  'ponte.glb',
  'torre.glb',
  'chiesa.glb',
  'tempio.glb',
  'castello.glb',
  'fortezza.glb',
  'muro.glb',
  'porta.glb',
  'finestra.glb',
  'scala.glb',
  'tavolo.glb',
  'sedia.glb',
  'letto.glb',
  'armadio.glb',
  'lampada.glb',
  'telefono.glb',
  'computer.glb',
  'libro.glb',
  'penna.glb',
  'orologio.glb',
  'bicchiere.glb',
  'piatto.glb',
  'forchetta.glb',
  'coltello.glb',
  'cucchiaio.glb'
]

// Funzione per testare se un modello esiste
const testModelExists = async (modelName) => {
  const url = `${ASSETS_CONFIG.baseUrl}/${modelName}`
  
  try {
    const response = await fetch(url, { method: 'HEAD' })
    return response.ok
  } catch (error) {
    console.log(`Errore nel test di ${modelName}:`, error.message)
    return false
  }
}

// Funzione per scoprire modelli disponibili
export const discoverModels = async () => {
  console.log('🔍 Inizio scoperta modelli sul server...')
  
  const discoveredModels = []
  const testPromises = POSSIBLE_MODELS.map(async (modelName) => {
    const exists = await testModelExists(modelName)
    if (exists) {
      const nameWithoutExt = modelName.replace('.glb', '')
      discoveredModels.push({
        name: nameWithoutExt,
        filename: modelName,
        url: `${ASSETS_CONFIG.baseUrl}/${modelName}`
      })
      console.log(`✅ Trovato: ${modelName}`)
    } else {
      console.log(`❌ Non trovato: ${modelName}`)
    }
  })
  
  await Promise.all(testPromises)
  
  console.log(`🎉 Scoperta completata! Trovati ${discoveredModels.length} modelli:`)
  discoveredModels.forEach(model => {
    console.log(`  - ${model.name}: ${model.url}`)
  })
  
  return discoveredModels
}

// Funzione per aggiungere automaticamente i modelli scoperti alla configurazione
export const addDiscoveredModels = async () => {
  const discovered = await discoverModels()
  
  discovered.forEach(model => {
    if (!ASSETS_CONFIG.models[model.name]) {
      ASSETS_CONFIG.addModel(model.name, model.filename)
    }
  })
  
  console.log('📝 Modelli aggiunti alla configurazione')
  return discovered
}

// Funzione per ottenere informazioni sui modelli configurati
export const getAvailableModelsInfo = () => {
  console.log('📋 Informazioni modelli configurati:')
  
  Object.entries(ASSETS_CONFIG.models).forEach(([name, url]) => {
    console.log(`  - ${name}: ${url}`)
  })
  
  return Object.keys(ASSETS_CONFIG.models)
}

// Funzione per testare tutti i modelli configurati
export const testAllConfiguredModels = async () => {
  console.log('🧪 Test di tutti i modelli configurati...')
  
  const testPromises = Object.keys(ASSETS_CONFIG.models).map(async (modelName) => {
    await testModelLoad(modelName)
  })
  
  await Promise.all(testPromises)
  console.log('✅ Test completato')
}

// Funzione per ottenere statistiche sui modelli
export const getModelStats = () => {
  const totalModels = Object.keys(ASSETS_CONFIG.models).length
  const localModels = Object.values(ASSETS_CONFIG.models).filter(url => url.startsWith('/')).length
  const remoteModels = totalModels - localModels
  
  return {
    total: totalModels,
    local: localModels,
    remote: remoteModels,
    remotePercentage: Math.round((remoteModels / totalModels) * 100)
  }
}

// Funzione per suggerire modelli basati su pattern
export const suggestModels = (pattern) => {
  const suggestions = POSSIBLE_MODELS.filter(model => 
    model.toLowerCase().includes(pattern.toLowerCase())
  )
  
  console.log(`💡 Suggerimenti per "${pattern}":`)
  suggestions.forEach(model => {
    console.log(`  - ${model}`)
  })
  
  return suggestions
} 